import { useCallback } from 'react';

import { useDialogStore } from '@/stores/dialog';

const useHideDialog = () => {
  const hide = useDialogStore(({ hide }) => hide);
  return useCallback(() => hide(), [hide]);
};

export default useHideDialog;
